import React, { Fragment, useContext, useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { Button, Image } from 'react-bootstrap';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import GSTDetails from 'components/sales/formSection/GSTDetails/gstDetails';
import ParkingRules from 'components/sales/formSection/parkingRules/parkingRules';
import MaterialHardware from 'components/sales/formSection/materialHardware/materialHardware';
import Tags from 'components/sales/formSection/materialHardware/tags';
import AdvancePayment from 'components/sales/formSection/materialHardware/advancePayment';
import Increament from 'components/sales/formSection/materialHardware/increament';
import ShippedTo from 'components/sales/formSection/shippedTo/shippedTo';
import BilledTo from 'components/sales/formSection/billedTo/billedTo';
import OtherDetails from 'components/sales/formSection/otherDetails/otherDetails';
import GateDetails from 'components/sales/formSection/gateDetails/gateDetailsApt';
import Commercial from 'components/sales/formSection/commercial/commercial';
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStone';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { handleValidateObj } from 'constants/objValues/objvalues';
import { Link } from 'react-router-dom';
import AgreementContract from 'components/sales/formSection/agreementContract/agreementContract';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import ClientDetails from "components/sales/formSection/clientDetails/clientDetails";
import InvoiceModule from 'components/sales/formSection/materialHardware/invoiceModule';

const PostSalesCorporate = (props) => {
  const {
    history,
    postCorporate,
    postCorData,
    pincodeData,
    locationPinCode,
    postSalesCorporateLead,
    getMaterial,
    getTag,
    getTagById,
    getMateriaById,
    getBrandById,
    getBrand,
    documentUploadUrl,
    documentUrlData,
    imageUploadUrl,
    videoUploadUrl,
    match,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress
  } = props;
  const { params } = match;
  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    parkingRules: null,
    shippedTo: null,
    // billedTo: null,
    clientData: null,
    installation: null,
    payment:[],
    otherDetails: null,
    gateDetails: null,
    tags:[],
    category: [],
    materialHardwares: null,
    gates: null,
    agreementDtls: null,
    InvoiceModuleData:null
  };

  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [sameAsBillTo, setSameAsBillTo] = useState(null);
  const [showAgreementDetails, setShowAgreementDetails] = useState(false);
  const [agreementLength, setAgreementLength] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);

  const [postCorporateData, setPostCorporateData] = useState(postDataInputs);
  const handleCommercial = (val) => {
    setPostCorporateData({ ...postCorporateData, commercial: val });
    if (val?.totalContract) {
      setShowAgreementDetails(true);
      setAgreementLength(val?.totalContract);
      // console.log(val);
    }
  };
  const handleGstDetails = (val) => {
    setPostCorporateData({ ...postCorporateData, gSTDetails: val });
  };
  const handleParkingRules = (val) => {
    setPostCorporateData({ ...postCorporateData, parkingRules: val });
  };
  const handleGateDtl = (val) => {
    setPostCorporateData({ ...postCorporateData, gateDetails: val });
    setIsGateDetailsChanged(true);
  };
  const handleMileStone = (val) => {
    setPostCorporateData({ ...postCorporateData, milestone: val });
  };
  // const handleBillTo = (val) => {
  //   setPostCorporateData({ ...postCorporateData, billedTo: val });
  // };
  const handleClientData = (val) => {
    setPostCorporateData({ ...postCorporateData, clientData: val });
  };
  const handleInstallation = (val) => {
    setPostCorporateData({ ...postCorporateData, installation: val });
  };
  const handlePayment = (val) => {
    setPostCorporateData({ ...postCorporateData, advPayment: val });
  };

  const handleIncreament = (val) => {
    setPostCorporateData({ ...postCorporateData, increamentData: val });
  };  
  const handleShippedTo = (val) => {
    setPostCorporateData({ ...postCorporateData, shippedTo: val });
  };
  const handleOtherDetails = (val) => {
    setPostCorporateData({ ...postCorporateData, otherDetails: val });
  };
  const handleGatesData = (val) => {
    setPostCorporateData({ ...postCorporateData, categoryInventory: val });
  };
  const handleProductData = (val) => {
    setPostCorporateData({ ...postCorporateData, productInventory: val });
  };
  const handleMaterialhardware = (val) => {
    setPostCorporateData({ ...postCorporateData, materialHardwares: val });
  };
  const handleTags = (val) => {
    setPostCorporateData({ ...postCorporateData, tagsData: val });
  };
  const handleagreementDtls = (val) => {
    setPostCorporateData({ ...postCorporateData, agreementDtls: val });
  };
  const handleInvoiceAmt = (val) => {
    setPostCorporateData({ ...postCorporateData, InvoiceModuleData: val });
  }; 

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

  // console.log(getTag);

  const handleSubmit = (id) => {
    setIsClicked(true);
    // console.log(postCorData.leadStatus);
    const {
      commercial,
      gSTDetails,
      // parkingRules,
      gateDetails,
      installation,
      // billedTo,
      shippedTo,
      clientData,
      // otherDetails,
      categoryInventory,
      productInventory,
      materialHardwares,
      tagsData,
      advPayment,
      increamentData,
      agreementDtls,
      milestone,
      InvoiceModuleData
    } = postCorporateData;
    if (
      (postCorData.leadStatus <= 4 &&
      (commercial != null &&
        // billedTo != null &&
        clientData !== null &&
        shippedTo != null &&
        agreementDtls != null &&
        gSTDetails != null ))
      ||
      (postCorData.leadStatus === 9 && (
        // otherDetails != null &&
        gateDetails != null &&
        materialHardwares != null
      ))  
       
    ) {
      setIsClicked(false);
      setIsFiled(false);

      if(clientData != null && clientData.billing_address !== undefined){
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          gateDetails: gateDetails,
          leadStatus:postCorData.leadStatus,
          isNewContract:0,
          comm_id:postCorData.comm_id,
          materialHardwares: { ...materialHardwares },
          ...clientData.billing_address
        };
      } else {
        var fObj = {
          ...commercial,
          ...installation,
          ...gSTDetails,
          // ...parkingRules,
          // ...billedTo,
          ...shippedTo,
          // ...otherDetails,
          ...agreementDtls,
          clientData: clientData,
          gateDetails: gateDetails,
          isNewContract:0,
          leadStatus:postCorData.leadStatus,
          comm_id:postCorData.comm_id,
          materialHardwares: { ...materialHardwares },
          // ...clientData.billing_address
        };
      }
      if (categoryInventory !== null && categoryInventory !== undefined && productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
          ...productInventory?.productData,
        ];
      } else if (categoryInventory !== null && categoryInventory !== undefined) {
        fObj.categoryInventory = [
          ...categoryInventory,
        ];
      } else if (productInventory !== null && productInventory !== undefined) {
        fObj.categoryInventory = [
          ...productInventory?.productData,
        ];      
      } else {
        fObj.categoryInventory = [];
      }

      if (tagsData !== null && tagsData !== undefined) {
        fObj.tags = [
          ...tagsData?.tagData,
        ];
      } else {
        fObj.tags = [];
      }

      if (advPayment !== null && advPayment !== undefined) {
        fObj.payment = [
          ...advPayment?.advData,
        ];
      } else {
        fObj.payment = [];
      }
      if (increamentData !== null && increamentData !== undefined) {
        fObj.increament = [
          increamentData,
        ];
      } else {
        fObj.increament = [];
      }
     
      if (milestone !== null && milestone != undefined) {
        let totalAmt = parseInt(postCorData?.commercialData?.total_mg_amount);
        let calculatedAmt = 0;
        if (!isNaN(totalAmt)) {
          if (totalAmt > 0) {
            for (let i = 0; i < postCorporateData.milestone?.milestone_data.length; i++) {
              if (postCorporateData.milestone.milestone_data[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.milestone_data[i].amt);
              }
            }
            for (let i = 0; i < postCorporateData.milestone?.date_invoices_data.length; i++) {
              if (postCorporateData.milestone.date_invoices_data[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.date_invoices_data[i].amt);
              }
            }
            for (let i = 0; i < postCorporateData.milestone?.retention.length; i++) {
              if (postCorporateData.milestone.retention[i].amt) {
                calculatedAmt += parseInt(postCorporateData.milestone.retention[i].amt);
              }
            }
            if (calculatedAmt > totalAmt) {
              toast.error('Milestone total amount is greater then capex amount!');
              setIsClicked(false);
              setIsFiled(true);
              return;
            } else {
              fObj.milestone=milestone;
            }
          }
        }
      }
      if(InvoiceModuleData !== null && InvoiceModuleData != undefined){
        let subsAmt = Number(postCorData?.commercialData?.subscription_amount);
        let invoiceAmt = InvoiceModuleData?.invoiceAmt;
        const initialValue = 0;
        const sumWithInitial = invoiceAmt.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
        );
        console.log(sumWithInitial);
        if(subsAmt === sumWithInitial ){
          fObj.InvoiceModuleData=InvoiceModuleData;
        }else{
          toast.error('Total amount of invoice module is not equal to the total subscription amount!');
          setIsClicked(false);
          setIsFiled(true);
          return;
        }
       

      }
    // console.log(fObj); return false;
      (async () => {
        const res = await postSalesCorporateLead({ ...fObj, leadId: id });
        if (res) {
          setIsModal(true);
        }
      })();
      
    } else {
      // console.log('false');
      setIsClicked(false);
      setIsFiled(true);
    }
  };

  useEffect(() => {
    (async () => await postCorporate(params.lead_id))();
  }, [postCorporate]);

  function refreshPage() {
    window.location.reload(false);
  }

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">
          {localization.save}
        </Button>
        <Button onClick={() => handleSubmit(params.lead_id)} disabled={isClicked}>
          {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
        </Button>
      </Fragment>
    );
  };
  // 
  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      className={isFiled ? 'requiredFileds' : ''}
      title={localization.addPost}
    >
      {postCorData.leadStatus <= 4 && (
        <>
      <Commercial
        data={postCorData}
        handleValue={handleCommercial}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        supplyNameFun={supplyNameFun}
        splNameData={splNameData}
      />
      <AgreementContract
        handleValue={handleagreementDtls}
        documentUploadUrl={documentUploadUrl}
        agreementLength={agreementLength}
        showDetails={showAgreementDetails}
      />
      <GSTDetails
        handleValue={handleGstDetails}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />
       {/* <BilledTo
        handleValue={handleBillTo}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
      />

      <Checkbox
        label={'Same shipping address'}
        type="checkbox"
        errorMsg={localization.isRequired}
        onChange={(val) => {
          if (val) {
            setSameAsBillTo(postCorporateData.billedTo);
          } else {
            setSameAsBillTo({
              billPinCode: '',
              billGeoCity: '',
              billGeoState: '',
              billGeoCityId: '',
              billGeoStateId: '',
              billPinId: '',
              billAddressLine1: '',
              billAddressLine2: '',
            });
          }
        }}
      /> */}
      <ShippedTo
        handleValue={handleShippedTo}
        locationPinCode={shipTolocationPinCode}
        pincodeData={shipToPincodeData}
        leadData={postCorData.lead_name}
        // sameAsBillTo={sameAsBillTo}
      />
      <ClientDetails
        handleValue={handleClientData}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        data={postCorData}
        clientBillingAddress={clientBillingAddress}
        clientBillingPocData={clientBillingPocData}
      />
      {/* <ParkingRules handleValue={handleParkingRules} data={postCorData} /> */}
      </>
      )}
      {/* postCorData.leadStatus */}
      {postCorData.leadStatus === 9 && (
        <>
       <GateDetails
        handleValue={handleGateDtl}
        data={postCorData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      />
       {(postCorData.commercialData?.commercial_type_id === 7 || postCorData.commercialData?.commercial_type_id === 6) && (
        <InvoiceModule
          handleValue={handleInvoiceAmt}
          data={postCorData} 
          prefilledData={postCorData?.postsale_data}
          invoiceAmtData = {postCorData?.postsale_data}
        />
      )}
        {postCorData.commercialData?.commercial_type_id === 5 && (
          <Milestone
            handleValue={handleMileStone}
            totalAmount={postCorData.commercialData}
            gateData={postCorporateData?.gateDetails}
            gateDetailsChanged = {setIsGateDetailsChanged} 
            isGateDetailsChanged = {isGateDetailsChanged} 
          />
        )}
      <MaterialHardware
        handleValue={handleMaterialhardware}
        data={postCorData}
        handleGatesData={handleGatesData}
        handleProductData={handleProductData}
        getMaterial={getMaterial}
        getMateriaById={getMateriaById}
        getBrandById={getBrandById}
        getBrand={getBrand}
      />
      <Tags
        handleValue={handleTags}
        data={postCorData}
       
      />


    <Installation
        handleValue={handleInstallation}
        isApartment={true}
      />

    <AdvancePayment
        handleValue={handlePayment}
        data={postCorData}
        imageUploadUrl={imageUploadUrl}
      />
    <Increament
        handleValue={handleIncreament}
        data={postCorData}
        imageUploadUrl={imageUploadUrl}
      />
     
      {/* <OtherDetails
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
        handleValue={handleOtherDetails}
        data={postCorData}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      /> */}
      </>
      )}
{postCorData.leadStatus <= 4 && (
  // postCorData.leadId
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <button onClick={refreshPage} className="btn btn-primary mb-4">
          {localization.saveAndNext} <img src={Images?.ArrowRight} alt="" />
          </button>
          {/* <Link
            to={`${baseUrl}/post-sales-corporate/${postCorData.leadId}`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link> */}
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
)}

{postCorData.leadStatus > 4 && (
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.postSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-transparent"
          >
            {localization.createAnother}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
)}

    </Layout>
  );
};

PostSalesCorporate.propTypes = {
  history: propTypes.any,
  postCorporate: propTypes.func,
};

export default PostSalesCorporate;
